import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { contactInfo, quickLinks } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_edu-social-design/artifacts/zll423im_Edusocial%20logo.jpg" 
                alt="EduSocial Logo" 
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-gray-600">{contactInfo.description}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4" style={{color: '#012726'}}>Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-600 transition-colors duration-200 text-sm"
                    onMouseEnter={(e) => e.target.style.color = '#33c375'}
                    onMouseLeave={(e) => e.target.style.color = ''}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="font-semibold mb-4" style={{color: '#012726'}}>Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-sm text-gray-600">
                <Mail size={16} style={{color: '#33c375'}} />
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="transition-colors duration-200"
                  onMouseEnter={(e) => e.target.style.color = '#33c375'}
                  onMouseLeave={(e) => e.target.style.color = ''}
                >
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-center space-x-2 text-sm text-gray-600">
                <Phone size={16} style={{color: '#33c375'}} />
                <a 
                  href={`tel:${contactInfo.phone}`}
                  className="transition-colors duration-200"
                  onMouseEnter={(e) => e.target.style.color = '#33c375'}
                  onMouseLeave={(e) => e.target.style.color = ''}
                >
                  {contactInfo.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-200 pt-6 text-center">
          <p className="text-sm text-gray-600">
            © {currentYear} EduSocial. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
